import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage, useIntl } from "react-intl";
import { useEffect } from "react";
import { fetchShowRedeemCoupons, fetchGetMessage } from "../../../../../../../api";
import { useState } from "react";
import { fetchUnifiedProcessing } from "../../../../utils";
import { useCallback } from "react";
import NormalConfigConfirm from "../../../../../../../client/components/alert/config-confirm";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

export default props =>{
    useStyles(cls);
    const { customer } = props;
    const [discountMsg, setDiscountMsg] = useState(null);
    const [couponShow, setCouponShow] = useState(false);
    const Intl = useIntl();
    const history = useHistory();
    const global = useSelector(state=>state.global);
    const { config } = global;

    useEffect(async () =>{
        let fetchData = await Promise.all([fetchShowRedeemCoupons(), fetchGetMessage("M1630")]);
        const [response1, response2] = fetchData;
        setCouponShow(fetchUnifiedProcessing(response1, false));
        setDiscountMsg(fetchUnifiedProcessing(response2));

        if(response1?.code === 200 && response1?.result){
            exposureEvent('Redeem');
        }
    }, []);

    useEffect(() =>{
        let geekoEventTypes = ['BuyEarn', 'Review', 'Suggestion', 'ReferFriend', 'Survey', 'MoreWays'];
        geekoEventTypes.forEach((typeName) =>{
            exposureEvent(typeName);
        });
    }, []);

    const exposureEvent = useCallback((typeName) =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('PitPositionExposure', {
                page_sort:"Me",
                page_content: "Points",
                resourcepage_title: `Point_${typeName}`,
                resource_content: typeName
            })
        }
    }, []);

    const recordEventSkip = useCallback((type, path, eventName, event) =>{
        // type true表示路由跳转  false表示window.location跳转
        // path 路径或者跳转的名字
        // eventName  事件的名字
        event.preventDefault();
        if(!!type){
            history.push(path);
        }else{
            window.location.href = path;
        }

        if(window.GeekoSensors){
            window.GeekoSensors.Track('PitPositionClick', {
                page_sort:"Me",
                page_content: "Points",
                resourcepage_title:`Points_${eventName}`,
                resource_content:eventName
            })
        }
    }, []);

    const buyEarnEvent = useCallback(async (evt) =>{
        evt.preventDefault();
        let response = await fetchGetMessage("M1624");
        if(response?.code === 200 && response?.result){
            const { result } = response;
            NormalConfigConfirm({
                boxStyle:{
                    padding:"15px 12px"
                },
                close:{
                    style:{
                        fontSize: "20px",
                        fontWeight: "bold",
                        top:"5px",
                        right:"4px"
                    }
                },
                title:{
                    text:Intl.formatMessage({ id: "buy_and_earn", defaultMessage: "Buy and Earn" }),
                    style:{
                        fontSize:"16px",
                        fontFamily: 'Roboto-Bold'
                    }
                },
                message:{
                    text: result?.message,
                    style:{
                        color:"#222222",
                        fontSize: '12px',
                        lineHeight: 'normal'
                    },
                    html:true
                },
                btn1:{
                    text:Intl.formatMessage({ id: "shop_now", defaultMessage: "Shop Now" }),
                    style:{
                        fontSize:"14px",
                        fontFamily: 'Roboto-Bold'
                    },
                    clickHandle:() =>{
                        window.location.href = "/";
                    }
                }
            });
        }

        if(window.GeekoSensors){
            window.GeekoSensors.Track('PitPositionClick', {
                page_sort:"Me",
                page_content: "Points",
                resourcepage_title:"Points_BuyEarn",
                resource_content:"BuyEarn"
            })
        }
    }, []);
    
    return <div className={cls.GetPoints}>
        <div className={cls.Title}><FormattedMessage id="how_to_get_points" defaultMessage="How to get points?" /></div>
        
        <div className={cls.Content}>
            <a className={cls.LinkItem} onClick={buyEarnEvent}>
                <div className={`${cls.ContentItem} ${cls.BuyEarn}`}>
                    <div>
                        <span className={cls.IconContainer}></span>
                    </div>

                    <div className={cls.Font}>
                        <p className={cls.Font1}><FormattedMessage id="buy_and_earn" defaultMessage="Buy and Earn" /></p>
                        {
                            discountMsg?.message && <p className={cls.Font2}>{discountMsg.message}</p>
                        }
                    </div>
                </div>
            </a>

            <a className={cls.LinkItem} onClick={(evt)=>recordEventSkip(true,'/user/order/confirmed','Review', evt)}>
                <div className={`${cls.ContentItem} ${cls.Review}`}>
                    <div>
                        <span className={cls.IconContainer}></span>
                    </div>

                    <div className={cls.Font}>
                        <p className={cls.Font1}><FormattedMessage id="review" defaultMessage="Review" /></p>
                        <p className={cls.Font2}>{`0~2000 ${Intl.formatMessage({ id: "points", defaultMessage: "points" })}`}</p>
                    </div>
                </div>
            </a>

            <a className={cls.LinkItem} onClick={(evt)=>recordEventSkip(true,'/user/suggestion','Suggestion', evt)}>
                <div className={`${cls.ContentItem} ${cls.Suggestion}`}>
                    <div>
                        <span className={cls.IconContainer}></span>
                    </div>

                    <div className={cls.Font}>
                        <p className={cls.Font1}><FormattedMessage id="suggestion" defaultMessage="Suggestion" /></p>
                        <p className={cls.Font2}>{`0~200 ${Intl.formatMessage({ id: "points", defaultMessage: "points" })}`}</p>
                    </div>
                </div>
            </a>
            
            {
                config?.app?.qrcode && <a className={cls.LinkItem} onClick={(evt)=>recordEventSkip(true,'/user/share','ReferFriend', evt)}>
                    <div className={`${cls.ContentItem} ${cls.Refer}`}>
                        <div>
                            <span className={cls.IconContainer}></span>
                        </div>

                        <div className={cls.Font}>
                            <p className={cls.Font1}><FormattedMessage id="refer_a_friend" defaultMessage="Refer a Friend" /></p>
                            <p className={cls.Font2}>{`Up to 500 ${Intl.formatMessage({ id: "points", defaultMessage: "points" })}`}</p>
                        </div>
                    </div>
                </a>
            }
            
            <a className={cls.LinkItem} onClick={(evt)=>recordEventSkip(true,'/user/survey','Survey', evt)}>
                <div className={`${cls.ContentItem} ${cls.Survey}`}>
                    <div>
                        <span className={cls.IconContainer}></span>
                    </div>

                    <div className={cls.Font}>
                        <p className={cls.Font1}><FormattedMessage id="survey" defaultMessage="Survey" /></p>
                        <p className={cls.Font2}>{`150 ${Intl.formatMessage({ id: "points", defaultMessage: "points" })}`}</p>
                    </div>
                </div>
            </a>

            <a className={cls.LinkItem} onClick={(evt)=>recordEventSkip(true, '/user/point-guide','MoreWays', evt)}>
                <div className={`${cls.ContentItem} ${cls.More}`}>
                    <div>
                        <span className={cls.IconContainer}></span>
                    </div>

                    <div className={cls.Font}>
                        <p className={cls.Font1}><FormattedMessage id="more_ways" defaultMessage="More Ways" /> {'>'}</p>
                    </div>
                </div>
            </a>
        </div>
        
        {
            couponShow && <div className={cls.RedeemCouponContainer}>
                <div className={cls.Title}><FormattedMessage id="hot_use_points" defaultMessage="How to Use Points?" /></div>
                
                <div className={cls.Content}>
                    <a className={cls.LinkItem} onClick={(evt)=>recordEventSkip(true, '/user/point-guide','MoreWays', evt)}>
                        <div className={`${cls.ContentItem} ${cls.RedeemCoupon}`}>
                            <div>
                                <span className={cls.IconContainer}></span>
                            </div>

                            <div className={cls.Font}>
                                <p className={cls.Font1}><FormattedMessage id="redeem_coupon" defaultMessage="Redeem Coupon" /></p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        }
        
    </div>
}